/* eslint-disable camelcase */

import { gql } from "@apollo/react-hooks";
import { CommandResult_Invoice, ListCommandResult_Invoice } from "@graphql/helpers/types.graphql";
import { CommandResult, ListCommandResult } from "@graphql/groups/fragment.graphql";
import utils, {
  TArchiveType,
  TConstructionType,
  TContractType,
  TFiscalDocumentType,
  TInvoiceInstallmentType,
  TInvoiceType,
  TJoin,
  TNonEmptyArray
} from "@graphql/helpers/utils.graphql";

type TInvoiceByIdFunctions = {
  getByID: CommandResult_Invoice;
};
export type TInvoiceByIdQueries = {
  invoice: TInvoiceByIdFunctions;
};

type TGlobal =
  | TInvoiceType
  | TJoin<"invoiceInstallments", TInvoiceInstallmentType>
  | TJoin<"invoiceInstallments.archive", TArchiveType>
  | TJoin<"archive", TArchiveType>
  | TJoin<"fiscalDocument", TFiscalDocumentType>
  | TJoin<"fiscalDocument.archive", TArchiveType>
  | TJoin<"contract", TContractType>
  | TJoin<"contract.construction", TConstructionType>;

export const invoiceById = (fields: TNonEmptyArray<TGlobal>) => gql`
  query invoiceById($id: Guid!) {
    invoice {
      getByID(id: $id) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_Invoice")}
`;

type TInvoiceAllWithPaginationFunctions = {
  getAllWithPagination: ListCommandResult_Invoice;
};
export type TInvoiceAllWithPaginationQueries = {
  invoice: TInvoiceAllWithPaginationFunctions;
};
export const invoiceAllWithPagination = (
  fields: TNonEmptyArray<TGlobal>
) => gql`
  query invoiceAllWithPagination($page: Int, $perPage: Int, $where: [WhereClausesInputType]) {
    invoice {
      getAllWithPagination(page: $page, perPage: $perPage, where: $where) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_Invoice")}
`;

type TInvoiceAllWithSortedPaginationFunctions = {
  getAllWithSortedPagination: ListCommandResult_Invoice;
};

export type TInvoiceAllWithSortedPaginationQueries = {
  invoice: TInvoiceAllWithSortedPaginationFunctions;
};

export const invoiceAllWithSortedPagination = (
  fields: TNonEmptyArray<TGlobal>
) => gql`
  query invoiceAllWithSortedPagination($page: Int, $perPage: Int, $where: [WhereClausesInputType], $sort: [SortClausesInputType]) {
    invoice {
      getAllWithSortedPagination(page: $page, perPage: $perPage, where: $where, sort: $sort) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_Invoice")}
`;
